import { SET_RULE_VALUE, RESET_RULES, SET_ALL_RULE_VALUE } from '../actionTypes';

const initialRule = {
  ruleName: '',
  ruleDescription: '',
  ruleWhen: ''
};

const workFlowRule = (state = initialRule, action) => {
  const { type, payload } = action;

  switch (type) {
    case SET_RULE_VALUE:
      const { keyName, ruleValue } = payload;
      return {
        ...state,
        [keyName]: ruleValue
      };

    case SET_ALL_RULE_VALUE:
      const { ruleValues } = payload;
      return ruleValues;

    case RESET_RULES:
      return initialRule;

    default:
      return state;
  }
};

export default workFlowRule;



// WEBPACK FOOTER //
// ./src/views/Setup/WorkFlow/flow/reducers/rule.js